import React from "react";
import mainStyle from "../../dashboard.module.scss";
import { styled, useTheme } from "@mui/material/styles";
import { Grid, Box, Typography, Divider } from "@mui/material";
import icn_site_network from "assets/images/icons/icn_site_network.svg";
import img_device_nvr_on from "assets/images/icons/img_device_nvr.svg";
import img_device_camera_on from "assets/images/icons/img_device_camera.svg";

const commonFlexStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const CommonTypography = styled(Typography)(({ theme }) => ({
  margin: 0,
  color: theme.palette.primary.greyPrimary,
  fontWeight: theme.typography.customFontWeight[3],
}));

const SiteNetworkStatus = ({ sortable, surveillanceStatus }) => {
  const theme = useTheme();

  const nvrOnline = surveillanceStatus?.nvr?.online ?? 0;
  const nvrOffline = surveillanceStatus?.nvr?.offline ?? 0;
  const nvrTotal = nvrOnline + nvrOffline;

  const camOnline = surveillanceStatus?.ipcam?.online ?? 0;
  const camOffline = surveillanceStatus?.ipcam?.offline ?? 0;
  const camTotal = camOnline + camOffline;

  return (
    <Box
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
      className={`main-card-content ${mainStyle["dndObj_card"]} ${
        sortable === true ? mainStyle["dndObj_edit"] : ""
      }`}
    >
      <Box className={mainStyle["dndObj_title"]} sx={{ display: "flex", alignItems: "center" }}>
        <img src={icn_site_network} alt="site_network_icon" />
        <Typography component="span" sx={{ marginLeft: "10px" }}>Site Network</Typography>
      </Box>

      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "center", pb: 2 }}>
        {/* Device Icons (No connecting line) */}
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={6} sx={commonFlexStyle}>
            <Box component="img" src={img_device_nvr_on} alt="NVR" sx={{ width: "40px", height: "40px" }} />
            <Typography sx={{ color: "primary.greyPrimary", fontWeight: theme.typography.customFontWeight[1], mt: 0.5 }}>
              NVRs
            </Typography>
          </Grid>
          <Grid item xs={6} sx={commonFlexStyle}>
            <Box component="img" src={img_device_camera_on} alt="Camera" sx={{ width: "40px", height: "40px" }} />
            <Typography sx={{ color: "primary.greyPrimary", fontWeight: theme.typography.customFontWeight[1], mt: 0.5 }}>
              Cameras
            </Typography>
          </Grid>
        </Grid>

        {/* Stats Row */}
        <Grid container justifyContent="center" alignItems="center" sx={{ mt: 2 }}>
          {/* NVR Stats */}
          <Grid item xs={6} sx={{ display: "flex", justifyContent: "center" }}>
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 2 }}>
              <Box sx={commonFlexStyle}>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Online
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[11], color: "primary.greenPrimary" }}>
                  {nvrOnline}
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Offline
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[11], color: "primary.greyThird" }}>
                  {nvrOffline}
                </CommonTypography>
              </Box>
              <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                sx={{ borderColor: "primary.greyThread", borderWidth: 1 }}
              />
              <Box sx={commonFlexStyle}>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Total
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[3], fontWeight: theme.typography.customFontWeight[1] }}>
                  {nvrTotal}
                </CommonTypography>
              </Box>
            </Box>
          </Grid>

          {/* Camera Stats */}
          <Grid item xs={6} sx={{ display: "flex", justifyContent: "center" }}>
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 2 }}>
              <Box sx={commonFlexStyle}>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Online
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[11], color: "primary.greenPrimary" }}>
                  {camOnline}
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Offline
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[11], color: "primary.greyThird" }}>
                  {camOffline}
                </CommonTypography>
              </Box>
              <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                sx={{ borderColor: "primary.greyThread", borderWidth: 1 }}
              />
              <Box sx={commonFlexStyle}>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[1] }}>
                  Total
                </CommonTypography>
                <CommonTypography sx={{ fontSize: theme.typography.customFontSize[3], fontWeight: theme.typography.customFontWeight[1] }}>
                  {camTotal}
                </CommonTypography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default SiteNetworkStatus;
